import React, { Component } from 'react';
import {
	Button,
	Checkbox,
	Col,
	ControlLabel,
	FormControl,
	FormGroup,
	OverlayTrigger,
	Popover,
	Row,
} from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { IS_VALID } from 'utils';

import ic_add_image from '../../../assets/image/ic_add_image.svg';
import Loader from '../../Loader';
import style from '../style.less';

class Create extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingRelation: false,
		};

		this.getRelation = this.getRelation.bind(this);
	}

	getRelation() {
		let {
			AppMenu,
			actions,

			getRelation,
		} = this.props;

		let { formType, selectedData } = AppMenu;

		if (IS_VALID(selectedData) && formType.toUpperCase() === 'UPDATE') {
			this.setState({ isLoadingRelation: true });

			getRelation()
				.then(([cardType, excludedCardType, specificUser, blacklistedUser]) => {
					let cardTypeArray = cardType.map((item) => ({
						label: item.get('name'),
						value: item.id,
					}));

					let excludedCardTypeArray = excludedCardType.map((item) => ({
						label: item.get('name'),
						value: item.id,
					}));

					let specificUserArray = specificUser.map((item) => ({
						label: `${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
							IS_VALID(item.get('name')) ? item.get('name') : ''
						}`,
						value: item.id,
					}));

					let blacklistedUserArray = blacklistedUser.map((item) => ({
						label: `${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
							IS_VALID(item.get('name')) ? item.get('name') : ''
						}`,
						value: item.id,
					}));

					this.setState({ isLoadingRelation: false });

					actions.setValue({
						cardType: cardTypeArray,
						excludedCardType: excludedCardTypeArray,
						specificUser: specificUserArray,
						blacklistedUser: blacklistedUserArray,
					});
				})
				.catch((err) => {
					console.log('getRelation error');
					console.log(err);

					this.setState({ isLoadingRelation: false });
				});
		}
	}

	render() {
		let { isLoadingRelation } = this.state;

		let {
			AppMenu,
			actions,

			loadOptions,
			uploadSpecificUserCSVFile,
		} = this.props;

		let {
			isLoadingAction,

			name,
			label,
			isEpicMillions,
			url,
			browser,
			isUseGoogleChrome,
			icon,
			isNew,
			position,
			sort,

			cardType,
			excludedCardType,
			specificUser,
			blacklistedUser,
			deviceType,
			isUploadingCSVFile,
			isUploadingCSVFileBlacklistedUser,
			deviceTypeOptions,
		} = AppMenu;

		let requiredSpan = <span style={{ color: 'red' }}>*</span>;

		let loadingComponent = (
			<div style={{ textAlign: 'center' }}>
				<i className="fa fa-spinner fa-spin"></i>
			</div>
		);
		let popupMessage = (component, message) => {
			return (
				<OverlayTrigger placement="top" id={message} overlay={<Popover>{message}</Popover>}>
					{component}
				</OverlayTrigger>
			);
		};

		let imageSrc = ic_add_image,
			imageStyle = {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				margin: 'auto',
				width: '100px',
				height: '100%',
			},
			dropZoneStyle = {
				display: 'inline-block',
				verticalAlign: 'top',
			},
			isHideX = {
				display: 'none',
			};

		if (IS_VALID(icon)) {
			imageSrc = icon.preview || icon.url;
			imageStyle = {
				...imageStyle,
				width: '',
				maxWidth: '100%',
				maxHeight: '100%',
			};
			dropZoneStyle = {
				verticalAlign: 'middle',
			};
			isHideX = {};
		}

		let isCardTypeFieldDisabled = specificUser.length !== 0 ? true : false;
		let isSpecificUserFieldDisabled = cardType.length !== 0 ? true : false;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Name {requiredSpan}</ControlLabel>
							<FormControl
								type="text"
								placeholder="Enter Name..."
								value={name}
								onChange={(e) => {
									actions.setValue({
										name: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Label {requiredSpan}</ControlLabel>
							<FormControl
								type="text"
								placeholder="Enter Label..."
								value={label}
								onChange={(e) => {
									actions.setValue({
										label: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel
								style={{
									width: '100%',
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<span>Browser {requiredSpan}</span>
								<Checkbox
									inline
									disabled={browser === null || browser.value === 'INTERNAL'}
									checked={isUseGoogleChrome}
									onChange={(e) => {
										actions.setValue({
											isUseGoogleChrome: e.target.checked,
										});
									}}
								>
									Use Google Chrome
								</Checkbox>
							</ControlLabel>
							<Select
								placeholder="Select Browser..."
								value={browser}
								onChange={(value) => {
									let stateToUpdate = {
										browser: value,
									};

									if (value === null || value.value === 'INTERNAL') {
										stateToUpdate.isUseGoogleChrome = false;
									}

									actions.setValue(stateToUpdate);
								}}
								options={[
									{
										label: 'Internal',
										value: 'INTERNAL',
									},
									{
										label: 'External',
										value: 'EXTERNAL',
									},
								]}
								clearable={false}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel
								style={{ display: 'flex', justifyContent: 'space-between' }}
							>
								<div>URL {requiredSpan}</div>
								<div>
									<Checkbox
										inline
										disabled={browser === null}
										checked={isEpicMillions}
										onChange={(e) => {
											actions.setValue({
												isEpicMillions: e.target.checked,
											});
										}}
									>
										Epic Millions
									</Checkbox>
								</div>
							</ControlLabel>
							<FormControl
								type="text"
								placeholder="Enter URL..."
								value={url}
								onChange={(e) => {
									actions.setValue({
										url: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						{/* <FormGroup>
                            <ControlLabel>Position {requiredSpan}</ControlLabel>
                            <Select
                                placeholder="Select Position..."
                                value={position}
                                onChange={(value) => {
                                    actions.setValue({
                                        position: value
                                    });
                                }}
                                options={[
                                    {
                                        label: "Top",
                                        value: "TOP"
                                    },
                                    {
                                        label: "Bottom",
                                        value: "BOTTOM"
                                    }
                                ]}
                                clearable={false}
                            />
                        </FormGroup> */}
						<FormGroup>
							<ControlLabel>Sort {requiredSpan}</ControlLabel>
							<FormControl
								type="number"
								placeholder="Enter Sort..."
								value={sort}
								onChange={(e) => {
									actions.setValue({
										sort: e.target.value.replace(/[^0-9.]/g, ''),
									});
								}}
							/>
						</FormGroup>
						<FormGroup>
							<Checkbox
								inline
								checked={isNew}
								onChange={(e) => {
									actions.setValue({
										isNew: e.target.checked,
									});
								}}
							>
								<b>New</b>
							</Checkbox>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Icon</ControlLabel>
							<div
								style={{
									position: 'absolute',
									width: '30px',
									height: '30px',
									background: 'white',
									paddingTop: '4px',
									top: '21px',
									right: '11px',
									textAlign: 'center',
									borderRadius: '50px',
									fontWeight: '600',
									cursor: 'pointer',
									...isHideX,
								}}
								onClick={() => {
									actions.setValue({ icon: null });
								}}
							>
								x
							</div>
							<Dropzone
								style={{
									position: '',
									width: '100%',
									height: '200px',
									border: '1px solid #e1e1e1',
									borderRadius: '0px',
									backgroundColor: '#f5f5f5',
									...dropZoneStyle,
								}}
								accept="image/*"
								multiple={false}
								onDropAccepted={(acceptedArray) => {
									actions.setValue({ icon: acceptedArray[0] });
								}}
							>
								<img style={imageStyle} src={imageSrc} />
							</Dropzone>
						</FormGroup>
					</Col>
				</Row>
				<hr />

				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>
								Card Type {!isCardTypeFieldDisabled && requiredSpan}&nbsp;
								{isCardTypeFieldDisabled
									? popupMessage(
											<i className="fa fa-info-circle"></i>,
											'Specific User is already assigned.'
									  )
									: ''}
							</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<Select.Async
									multi={true}
									disabled={isCardTypeFieldDisabled}
									placeholder="Select or Search..."
									loadOptions={(input, cb) =>
										loadOptions(input, cb, 'VoucherCardType', 'name')
									}
									value={cardType}
									onChange={(value) => {
										actions.setValue({
											cardType: value,
										});
									}}
									className={style.select}
								/>
							)}
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Excluded Card Type</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<Select.Async
									multi={true}
									placeholder="Select or Search..."
									loadOptions={(input, cb) =>
										loadOptions(input, cb, 'VoucherCardType', 'name')
									}
									value={excludedCardType}
									onChange={(value) =>
										actions.setValue({ excludedCardType: value })
									}
									className={style.select}
								/>
							)}
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Device Type</ControlLabel>
							<Select
								clearable={false}
								options={deviceTypeOptions}
								value={deviceType}
								onChange={(deviceType) => {
									actions.setValue({
										deviceType,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>
								Specific User&nbsp;
								{isSpecificUserFieldDisabled
									? popupMessage(
											<i className="fa fa-info-circle"></i>,
											'Card Type is already assigned.'
									  )
									: ''}
								{IS_VALID(specificUser) && specificUser.length > 0
									? `: Total ${specificUser.length}`
									: ''}
							</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<div>
									<Select.Async
										placeholder="Select or Search..."
										multi={true}
										disabled={isSpecificUserFieldDisabled}
										loadOptions={(input, cb) =>
											loadOptions(input, cb, 'MemberDetail')
										}
										value={specificUser}
										onChange={(value) =>
											actions.setValue({ specificUser: value })
										}
										className={style.select}
									/>
									<br />
									<Row>
										<Col
											md={
												IS_VALID(specificUser) && specificUser.length > 10
													? 6
													: 12
											}
										>
											<Button
												style={{ width: '100%' }}
												disabled={
													isUploadingCSVFile ||
													isSpecificUserFieldDisabled
												}
												onClick={() => {
													this.dropzoneRef.name = 'specificUser';
													this.dropzoneRef.open();
												}}
											>
												{isUploadingCSVFile ? (
													<i className="fa fa-spinner fa-spin"></i>
												) : (
													<b>UPLOAD SPECIFIC USER CSV</b>
												)}
											</Button>
											<p style={{ margin: '10px 0 0' }}>
												Note: CSV file must have a "memberId" column
											</p>
										</Col>
									</Row>
								</div>
							)}
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>
								Excluded User&nbsp;
								{IS_VALID(blacklistedUser) && blacklistedUser.length > 0
									? `: Total ${blacklistedUser.length}`
									: ''}
							</ControlLabel>
							{isLoadingRelation ? (
								loadingComponent
							) : (
								<div>
									<Select.Async
										placeholder="Select or Search..."
										multi={true}
										loadOptions={(input, cb) =>
											loadOptions(input, cb, 'MemberDetail')
										}
										value={blacklistedUser}
										onChange={(value) =>
											actions.setValue({ blacklistedUser: value })
										}
										className={style.select}
									/>
									<br />
									<Row>
										<Col
											md={
												IS_VALID(blacklistedUser) &&
												blacklistedUser.length > 10
													? 6
													: 12
											}
										>
											<Button
												style={{ width: '100%' }}
												disabled={isUploadingCSVFileBlacklistedUser}
												onClick={() => {
													this.dropzoneRef.name = 'blacklistedUser';
													this.dropzoneRef.open();
												}}
											>
												{isUploadingCSVFileBlacklistedUser ? (
													<i className="fa fa-spinner fa-spin"></i>
												) : (
													<b>UPLOAD EXCLUDED USER CSV</b>
												)}
											</Button>
											<p style={{ margin: '10px 0 0' }}>
												Note: CSV file must have a "memberId" column
											</p>
										</Col>
									</Row>
								</div>
							)}
						</FormGroup>
					</Col>
				</Row>
				<Dropzone
					accept=".csv, text/csv"
					style={{ display: 'none' }}
					multiple={false}
					ref={(ref) => {
						this.dropzoneRef = ref;
					}}
					onDropAccepted={(acceptedArray) => {
						uploadSpecificUserCSVFile(acceptedArray[0], this.dropzoneRef.name);
					}}
				/>
			</form>
		);
	}

	componentDidMount() {
		this.getRelation();
	}
}

function mapStateToProps(state) {
	let { AppMenu } = state;

	return {
		AppMenu,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppMenu/FormContainer/Create.js